export default __webpack_public_path__ + "static/gelato-70d781a2270bd8f67b79d6de964d482a.svg";